export const client = {
  api: null as any,
  path: {}
};
